import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import useTheme from "../../../components/web/layoutscommon/DarkModeStorage";
import StoreTermsPopup from "./StoreTermsPopup";
import StoreAuthShell from "./StoreAuthShell";
import {Btn, ErrorText, Field} from "./StoreUI";
import {storeLogin, isStoreLoggedIn, STORE_DASHBOARD_PATH} from "../../../services/storeApi";

/**
 * 상점사(쇼핑몰) 로그인
 *  - 경로 : /store/api/login
 *  - 자동로그인 체크박스 / sessionStorage 없이 localStorage 로만 로그인한다(스펙).
 *  - 한국 쇼핑몰 대상 화면이므로 번역 없이 한국어 고정.
 */
function StoreLoginPg() {

    const [theme] = useTheme();
    const navigate = useNavigate();

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [errorMsg, setErrorMsg] = useState('');
    const [loading, setLoading] = useState(false);

    const [termsOfUsePopup, setTermsOfUsePopup] = useState(false);
    const [privacyPolicyPopup, setPrivacyPolicyPopup] = useState(false);

    // 이미 로그인 상태면 대시보드로
    useEffect(() => {
        if (isStoreLoggedIn()) navigate(STORE_DASHBOARD_PATH, {replace: true});
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleLogin = async () => {
        if (loading) return;
        setErrorMsg('');

        if (!email.trim()) {
            setErrorMsg('이메일을 입력해주세요');
            return;
        }
        if (!password) {
            setErrorMsg('비밀번호를 입력해주세요');
            return;
        }

        setLoading(true);
        try {
            await storeLogin(email.trim(), password);
            navigate(STORE_DASHBOARD_PATH, {replace: true});
        } catch (e) {
            setErrorMsg(e?.response?.data?.message || '이메일 또는 비밀번호가 올바르지 않습니다');
        } finally {
            setLoading(false);
        }
    };

    const onKeyDown = (e) => {
        if (e.key === 'Enter') handleLogin();
    };

    return (
        <StoreAuthShell theme={theme}
                        title="상점사 로그인"
                        desc="자사 상점(Web/App)의 상품 페이지 및 장바구니 페이지에 비토리지의 구매대행 및 해외배송 서비스를 연동하세요"
                        onTerms={() => setTermsOfUsePopup(true)}
                        onPrivacy={() => setPrivacyPolicyPopup(true)}>

            <Field label="이메일">
                <input className="st-input" type="text" value={email} maxLength={50} autoComplete="username"
                       placeholder="example@company.com"
                       onChange={(e) => setEmail(e.target.value)} onKeyDown={onKeyDown}/>
            </Field>

            <Field label="비밀번호">
                <input className="st-input" type="password" value={password} maxLength={20} autoComplete="current-password"
                       placeholder="비밀번호를 입력해주세요"
                       onChange={(e) => setPassword(e.target.value)} onKeyDown={onKeyDown}/>
            </Field>

            {errorMsg ? <ErrorText>{errorMsg}</ErrorText> : null}

            <Btn tone="dawn" size="lg" className="tw-mt-4 tw-w-full" onClick={handleLogin}
                 disabled={loading} busy={loading}>
                로그인
            </Btn>

            <div className="tw-mt-6 tw-flex tw-items-center tw-justify-center tw-gap-3 tw-text-[13px]">
                <button type="button" className="st-link" onClick={() => navigate('/store/api/join')}>회원가입</button>
                <span aria-hidden="true" className="tw-text-[color:var(--st-text-faint)] tw-opacity-40">·</span>
                <button type="button" className="st-link" onClick={() => navigate('/store/api/findpw')}>비밀번호 찾기</button>
            </div>

            {termsOfUsePopup ?
                <StoreTermsPopup termsOfUsePopup={termsOfUsePopup} closeTermsPopup={() => setTermsOfUsePopup(false)}/>
                : null}
            {privacyPolicyPopup ?
                <StoreTermsPopup privacyPolicyPopup={privacyPolicyPopup} closeTermsPopup={() => setPrivacyPolicyPopup(false)}/>
                : null}
        </StoreAuthShell>
    );
}

export default StoreLoginPg;
